export default __webpack_public_path__ + "3c92912b41be9a42b6e6320de7e97762.svg";